// extracted by mini-css-extract-plugin
export default {"wrapper":"T2-z","play":"U2-z"};